import { render } from "./ManageEmailSubscriptionView.vue?vue&type=template&id=1b80b090"
import script from "./ManageEmailSubscriptionView.vue?vue&type=script&lang=js"
export * from "./ManageEmailSubscriptionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__